import React from 'react';

import { RHFSelect } from '@/Components/shadcn/rhf-select';
import UIStrings from '@/Utils/UIStrings';
import workExperienceOptions from './WorkExperienceOptions';
import { JobDetailsFieldTypes } from '../JobDetailsStepUtils';

function WorkExperience(): React.JSX.Element {
    const options = workExperienceOptions.map((o) => ({ id: String(o.id), name: o.name }));

    return (
        <RHFSelect
            label={`${UIStrings.WorkExperience}*`}
            name={JobDetailsFieldTypes.WorkExperience}
            options={options}
            fieldDataCy={JobDetailsFieldTypes.WorkExperience}
        />
    );
}

export default WorkExperience;
